// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--zjS0m";
export var content = "Layout-module--content--m7rwP";